document.addEventListener('DOMContentLoaded', function () {
    const birthstoneDrawerOpenBtn = document.querySelector('.personalize-birthstone-btn');
    const customDrawer = document.querySelector('.custom_drawer');
    const closeDrawerIcon = document.querySelector('.close-icon-drawer');
    const backBtn = document.querySelector('.birthstone-back-btn');

    function closeDrawer() {
      document.body.classList.remove('custom_drwer');
      customDrawer.classList.add('hidden');
    }

    birthstoneDrawerOpenBtn.addEventListener('click', () => {
      document.body.classList.add('custom_drwer');
      customDrawer.classList.remove('hidden');
    });

    closeDrawerIcon.addEventListener('click', closeDrawer);
    backBtn.addEventListener('click', closeDrawer);

    document.querySelectorAll('.birthstone-header').forEach((header) => {
      header.addEventListener('click', () => {
        const parent = header.parentElement;
        const isOpen = parent.classList.contains('active');

        // Close all
        document.querySelectorAll('.birthstone-item').forEach((item) => {
          item.classList.remove('active');
          item.querySelector('.icon').textContent = '+';
        });

        // Open clicked
        if (!isOpen) {
          parent.classList.add('active');
          header.querySelector('.icon').textContent = '−';
        }
      });
    });
  });